import React from "react";
import { WlakthroughView } from "./walkthrough-view";
export const WalkthroughController = (props) => {
	const [open, setOpen] = React.useState(true);
	const handleOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};
	return <WlakthroughView open={open} handleOpen={handleOpen} handleClose={handleClose} {...props} />;
};
